export default __webpack_public_path__ + "static/media/login-carousel-1.d68ef9dc.svg";